import React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

interface ConfirmationDialogProps {
  modalOpen: boolean
  onClose: (value: boolean) => void
  onSubmit: () => void
  dialogTitleContent?: React.ReactNode
  children: React.ReactNode
  confirmationBtnProps?: React.ComponentProps<typeof Button>
  cancelBtnProps?: React.ComponentProps<typeof Button>
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ ...props }) => {
  const {
    modalOpen, onClose, onSubmit, dialogTitleContent, children, cancelBtnProps, confirmationBtnProps
  } = props

  return (
    <Dialog fullWidth open={modalOpen} onClose={() => onClose(false)} maxWidth="xs"
      slotProps={{
        paper: {
          sx: { padding: 2, gap: 1 }
        }
      }}
    >
      {dialogTitleContent && (
        <>
          <DialogTitle sx={{ px: 3, py: 2 }}>{dialogTitleContent}</DialogTitle>
        </>
      )}

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 1,
          px: 3
        }}
      >
        {children}
      </DialogContent>

      <DialogActions sx={{ gap: 1 }}>
        <Button
          variant="text"
          size="medium"
          color={cancelBtnProps?.color || "error"}
          onClick={() => onClose(false)}
          type="button"
          autoFocus={false}
          sx={{ textTransform: 'none' }}
          data-testid="cancel-dialog-button"
          {...cancelBtnProps}
        >
          {cancelBtnProps?.title || 'Cancelar'}
        </Button>

        <Button
          variant="contained"
          size="medium"
          color={confirmationBtnProps?.color || "success"}
          type="button"
          autoFocus={false}
          onClick={() => onSubmit()}
          sx={{ textTransform: 'none' }}
          data-testid="confirm-dialog-button"
          {...confirmationBtnProps}
        >
          {confirmationBtnProps?.title || 'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
